import { customerQueryKey } from '@services/customer/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useDeleteCustomerDocument = (customerId: string) => {
  const queryClient = useQueryClient();
  const client = useClient();
  const result = useMutation({
    mutationFn: (documentId: string) => client.delete(`customer/${customerId}/document/${documentId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: customerQueryKey._customerDocument(customerId) });
    },
  });
  return { ...result, deleteCustomerDocumentAsync: result.mutateAsync };
};
